export default {
  sm: `
  IT services face new changes and data continues to increase. Power consumption will continue to increase accordingly. DATA CENTER GAK continues to research and develop ways to reduce energy consumption and carbon emissions and making efforts to put them in practice for the future generations.
  `,
};
